// Each platform's own embed script, loaded once per page and only when a
// post from that platform is on it. A blocked script (an ad blocker, a
// privacy setting) leaves the post as the plain link inside it, which is
// what every platform's embed markup is built to fall back to.

const loading = new Map();

export function loadScript(src, attrs = {}) {
    if (typeof document === 'undefined') return Promise.reject(new Error('no document'));
    if (loading.has(src)) return loading.get(src);
    const p = new Promise((resolve, reject) => {
        const el = document.createElement('script');
        el.src = src;
        el.async = true;
        for (const [k, v] of Object.entries(attrs)) el.setAttribute(k, v);
        el.onload = () => resolve();
        el.onerror = () => { loading.delete(src); reject(new Error(`could not load ${src}`)); };
        document.head.appendChild(el);
    });
    loading.set(src, p);
    return p;
}

export async function processInstagram() {
    await loadScript('https://www.instagram.com/embed.js');
    window.instgrm?.Embeds?.process?.();
}

export async function processX(el) {
    await loadScript('https://platform.twitter.com/widgets.js', { charset: 'utf-8' });
    await window.twttr?.widgets?.load?.(el);
}

export async function processFacebook(el) {
    if (!document.getElementById('fb-root')) {
        const root = document.createElement('div');
        root.id = 'fb-root';
        document.body.appendChild(root);
    }
    await loadScript('https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v21.0', { crossorigin: 'anonymous' });
    window.FB?.XFBML?.parse?.(el);
}
